import introspectionResult from 'lib/graphql/generated/fragmentMatcher';
import { IntrospectionFragmentMatcher } from 'apollo-cache-inmemory';

export const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData: introspectionResult,
});
